import React from 'react';



function ListVenueSL(props) {
  return (
    <div className='flex  bg-slate-100 rounded-lg shadow-xl overflow-hidden '>
      <div className='h-48 animate-pulse bg-slate-300 aspect-square ' />
      <div className='p-2 animate-pulse w-3/5 flex flex-col ml-4 gap-y-1.5 mt-2'>
        <div className='flex'>
          <p className='flex w-6 bg-slate-300 items-center text-sm font-semibold'>

          </p>
          <div className="flex w-36 ml-2 items-center bg-slate-300">
            &nbsp;
          </div>
        </div>

        <div className="mt-4 flex items-center bg-slate-300">
          &nbsp;

        </div>

        <div className='flex items-center'>
          <p className='mt-4 text-sm w-full bg-slate-300 text-gray-600'>&nbsp;  </p>

        </div>

      </div>

    </div>
  );
}

export default ListVenueSL;